<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('menu.meetingL') }}</div>
                <div class="mainBody">
                    <div class="meeting">
                        <p @click="pdf(item.id)" v-for="item in pdfList" :key="item.id">{{ item.title }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <div v-if="pdfShow">
            <div class="mask" @click="pdfShow = false"></div>
            <div v-if="loading" class="home_wrap">
                <img src="https://oss.eventnet.cn/H5/Nissan_meeting/2022/loading.gif?v=0223"
                    style="width: .8rem;height: .8rem;" alt="">
                <p style="font-size: .28rem;color: #fff;margin-top: .2rem">{{ $t('meetingL.loading') }}</p>
            </div>
            <div class="home_wrap" v-if="!loading">
                <img @click="pdfShow = false; loading = true;" class="close" width=".4rem" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/close_icon.png"
                    alt="">
                <p>{{ $t('meetingL.tips1') }}</p>
                <div :style="{ width: pdf_div_width, margin: '0 auto' }">
                    <div v-for="(item, index) in list" :key="index" class="image-container" :data-src="item"
                        :data-original-src="getOriginalUrl(item)" :style="{
                            'margin-bottom': '.2rem',
                            'background': 'url(' + item + ') no-repeat',
                            'width': '7rem',
                            'height': '4rem',
                            'background-size': '100%'
                        }" @click="bigImg">
                    </div>
                </div>
            </div>
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
import Photo from "../../components/PhotoSwipe.vue"
export default {
    components: {
        menus, Photo
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            lang: "",
            pdf_div_width: '',
            toastText: '',
            toastShow: false,
            pdfShow: false,
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
            list: [],
            loading: true,
            language: this.$route.query.lang == 'zh' ? '1' : '2',//this.$route.query.lang == 'zh' ? '1' : '2'
            pdfList: [],
            le: new Date().getTime(),
            watermarkCache: {}, // 添加水印缓存
            observer: null,
            name: '',
        }
    },
    created() {
        this.lang = this.$route.query.lang;

    },
    mounted() {
        let that = this;
        let data = new FormData();
        data.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
        that.axios.post('init', data).then(res => {
            if (res.data.code == 200) {
                that.name = res.data.name;
                that.observer = this.setupIntersectionObserver();
            } else {
                that.$router.replace('/login').catch(err => err);
            }
        }).catch(err => { });

        let data1 = new FormData();
        data1.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
        data1.append('lang', localStorage.getItem("nissan2023_meeting_lang") == 'zh' ? '1' : '2');
        that.axios.post('MeetingMaterialsList', data1).then(res => {
            if (res.data.code == 200) {
                that.pdfList = res.data.data;
            } else {
                that.$router.replace('/login').catch(err => err);
            }
        }).catch(err => { });

    },
    methods: {
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        },
        async pdf(id) {
            let that = this, data1 = new FormData();
            that.list = [];
            data1.append('uuid', localStorage.getItem("nissan2023_meeting_uuid"));
            data1.append('mid', id);
            
            try {
                that.loading = true;
                that.pdfShow = true;

                const res = await that.axios.post('MeetingMaterials', data1);
                if (res.data.code == 200) {
                    // 初始化图片列表
                    res.data.data.forEach(item => {
                        that.list.push(item.address);
                    });

                    // 分批处理水印
                    const batchSize = 3;
                    const concurrentBatches = 2;

                    for (let i = 0; i < that.list.length; i += (batchSize * concurrentBatches)) {
                        try {
                            const batchPromises = [];

                            for (let j = 0; j < concurrentBatches; j++) {
                                const startIndex = i + (j * batchSize);
                                const endIndex = Math.min(startIndex + batchSize, that.list.length);

                                if (startIndex < that.list.length) {
                                    const batch = that.list.slice(startIndex, endIndex);
                                    const batchPromise = Promise.all(
                                        batch.map(async (url, batchIndex) => {
                                            try {
                                                const watermarkedUrl = await that.addWatermark(url);
                                                that.$set(that.list, startIndex + batchIndex, watermarkedUrl);
                                                return watermarkedUrl;
                                            } catch (err) {
                                                console.error('Water mark processing error:', err);
                                                return url; // 如果水印处理失败，返回原始URL
                                            }
                                        })
                                    );
                                    batchPromises.push(batchPromise);
                                }
                            }

                            if (batchPromises.length > 0) {
                                await Promise.all(batchPromises).catch(err => {
                                    console.error('Batch processing error:', err);
                                });
                            }
                        } catch (err) {
                            console.error('Error in batch:', err);
                            continue; // 继续处理下一批次
                        }
                    }
                } else {
                    that.$router.replace('/login').catch(err => err);
                }
            } catch (err) {
                console.error('PDF processing error:', err);
                that.toast('处理失败，请重试');
            } finally {
                that.loading = false;
            }
        },
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
            }, 1500)
        },
        getImgInfo(url) {
            let that = this, img = new Image()
            img.src = url
            img.onload = function () {
                // console.log('图片原始宽度', img.width)
                // console.log('图片原始高度', img.height)
            }
        },
        getOriginalUrl(url) {
            // 如果在缓存中找不到这个URL，说明它就是原始URL
            // 如果找到了，返回对应的原始URL（作为key存储在缓存中）
            for (const [originalUrl, watermarkedUrl] of Object.entries(this.watermarkCache)) {
                if (watermarkedUrl === url) {
                    return originalUrl;
                }
            }
            return url;
        },
        bigImg(el) {
            let that = this, img = new Image();
            const watermarkedSrc = el.target.style.backgroundImage.slice(4, -1).replace(/"/g, "");
            img.src = watermarkedSrc;
            console.log(img.src);
            img.onload = function () {
                that.items[0].w = 2520;
                that.items[0].h = 1417;
                that.items[0].src = watermarkedSrc;
                that.bigImg_show = true;
            }
        },
        close(e) {
            this.bigImg_show = e;
        },
        addWatermark(imageUrl) {
            let that = this;
            if (this.watermarkCache[imageUrl]) {
                return Promise.resolve(this.watermarkCache[imageUrl]);
            }

            return new Promise((resolve) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.src = imageUrl;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // 缩小canvas尺寸以提升性能
                    const scale = Math.min(1, 1000 / img.width);
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;

                    // 绘制原图
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    // 创建更小的水印图案
                    const watermarkCanvas = document.createElement('canvas');
                    const watermarkCtx = watermarkCanvas.getContext('2d');

                    // 减小水印画布大小
                    watermarkCanvas.width = 150;
                    watermarkCanvas.height = 100;

                    // 设置水印样式
                    watermarkCtx.font = '16px Arial';
                    watermarkCtx.fillStyle = 'rgba(177, 177, 177, 0.2)';
                    watermarkCtx.textAlign = 'center';
                    watermarkCtx.translate(75, 50);
                    watermarkCtx.rotate(-Math.PI / 6);
                    watermarkCtx.fillText(that.name, 0, 0);

                    // 创建平铺图案
                    const pattern = ctx.createPattern(watermarkCanvas, 'repeat');
                    ctx.fillStyle = pattern;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);

                    canvas.toBlob((blob) => {
                        const url = URL.createObjectURL(blob);
                        this.watermarkCache[imageUrl] = url;
                        resolve(url);
                    }, 'image/jpeg', 1); // 降低质量以减小文件大小
                };
            });
        },
        // 添加观察者，监听图片是否进入可视区域
        setupIntersectionObserver() {
            const options = {
                root: null,
                rootMargin: '50px',
                threshold: 0.1
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        const originalSrc = img.getAttribute('data-src');
                        if (originalSrc) {
                            this.addWatermark(originalSrc).then(watermarkedSrc => {
                                img.src = watermarkedSrc;
                            });
                            observer.unobserve(img); // 处理完后停止观察
                        }
                    }
                });
            }, options);

            return observer;
        },
        // 在组件销毁前清理 Blob URLs
        clearWatermarkCache() {
            Object.values(this.watermarkCache).forEach(url => {
                URL.revokeObjectURL(url);
            });
            this.watermarkCache = {};
        }
    },
    beforeDestroy() {
        // 清理观察者和 Blob URLs
        if (this.observer) {
            this.observer.disconnect();
        }
        this.clearWatermarkCache();
    }
}
</script>
<style scoped>
.mask {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.9);
    left: 0;
    top: 0;
    z-index: 1000;
}

.home_wrap {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    position: fixed;
    width: 7rem;
    height: 90%;
    z-index: 1001;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.home_wrap>div {
    flex: 1;
    height: 100%;
    overflow-y: scroll;
    width: 100% !important;
}


.close {
    position: absolute;
    width: 0.5rem;
    right: 0;
    top: 0;
}

.home_wrap>p {
    color: #fff;
    font-size: 0.3rem;
    padding-bottom: 0.4rem;
    font-weight: bold;
}

.pdf_down {
    position: fixed;
    display: flex;
    z-index: 20;
    right: 26px;
    bottom: 7%;
}

.pdf_set_left {
    width: 30px;
    height: 40px;
    color: #408fff;
    font-size: 11px;
    padding-top: 25px;
    text-align: center;
    margin-right: 5px;
    cursor: pointer;
}

.pdf_set_middle {
    width: 30px;
    height: 40px;
    color: #408fff;
    font-size: 11px;
    padding-top: 25px;
    text-align: center;
    margin-right: 5px;
    cursor: pointer;
}

canvas {
    width: 100% !important;
    height: auto !important;
}

.img {
    width: 100%;
}

.img img {
    width: 100%;
}

.meeting p {
    display: block;
    line-height: .6rem;
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto .2rem;
    padding: .1rem .15rem;
    background: url(https://oss.eventnet.cn/H5/Nissan_meeting/2024/input_bg.png) no-repeat;
    background-size: 100% 100%;
    border-radius: .1rem;
    font-size: .28rem;
    color: #0b8383;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/meetingL/meeting.vue